import { createContext } from "react";
import useLocalStorage from "../hooks/useLocalStorage";

const initialState = {
  themeMode: "light",
  onToggleMode: () => {},
};

const SettingsContext = createContext(initialState);

interface Props {
  children: React.ReactNode;
}

function SettingsProvider({ children }: Props) {
  const [settings, setSettings] = useLocalStorage("settings", {
    themeMode: initialState.themeMode,
  });

  const onToggleMode = () => {
    setSettings({
      ...settings,
      themeMode: settings.themeMode === "light" ? "dark" : "light",
    });
  };

  return (
    <SettingsContext.Provider
      value={{
        ...settings,
        onToggleMode,
      }}
    >
      {children}
    </SettingsContext.Provider>
  );
}

export { SettingsProvider, SettingsContext };
